import styled from "styled-components";

export const StepDescription = styled("p")<{ $vertical: boolean }>(
  ({ $vertical }) => `
  text-align: ${$vertical ? "center" : "start"};
`,
);
